import React from "react";
import { MdCardGiftcard } from "react-icons/md";

import styles from "./BonusInfo.module.scss";

interface Props {
  balance: number;
  percent: number;
}

export const BonusInfo: React.FC<Props> = ({ balance, percent }) => {
  return (
    <div className={styles.Container}>
      <div className={styles.Header}>
        <MdCardGiftcard size={20} className={styles.Icon} />
        <h3 className={styles.Title}>Мои бонусы</h3>
      </div>

      <div className={styles.Row}>
        <span className={styles.Label}>Доступно</span>
        <span className={styles.Value}>{balance} ₽</span>
      </div>

      <div className={styles.Row}>
        <span className={styles.Label}>Кешбэк за заказ</span>
        <span className={styles.Percent}>{percent}%</span>
      </div>
    </div>
  );
};
